const currencyCodes = [{ code: "de-DE", value: "EUR", symbol: "€" }, { code: "en-GB", value: "GBP", symbol: "£" }, { code: "en-US", value: "USD", symbol: "$" }, { code: "de-DE", value: "CHF", symbol: "CHF" }]


export default (price, currency) => {
  const currencyCode = currencyCodes.find(code => code.value === currency)
  console.log(currency)
  return currencyCode.symbol + " " + parseFloat(price).toFixed(2).toLocaleString()
}
